import { generatePath } from "react-router-dom";
import { APPROVALS_TAB_PATH, ApprovalsTab } from "@/constants";

export const approvalTabsConfig = [
  {
    id: ApprovalsTab.Inbox,
    link: generatePath(APPROVALS_TAB_PATH, { tab: ApprovalsTab.Inbox }),
    label: "Inbox",
  },
  {
    id: ApprovalsTab.Tracking,
    link: generatePath(APPROVALS_TAB_PATH, { tab: ApprovalsTab.Tracking }),
    label: "Tracking",
  },
];
